var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{staticClass:"mt-5",attrs:{"action":"/api/v1/banka/","place-holder":'Banka Seçiniz',"return-id":_vm.returnId,"auto-complete":"","cache-active":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }